import React from 'react';

import AcknowledgementStateChip from 'components/AcknowledgementStateChip';

import { ColumnDefinition } from 'components/Grid/types';

import { Value } from 'components/DueDate/styles';

import { colors } from 'theme/colors';

import { AcknowledgementState, MyAcknowledgementRow } from 'utils/api/modules/entities/entities.types';

import { formatDateOmitCurrentYear } from 'utils/date';

import { StyledTaskDueDate } from '../TasksTable/styles';
import { DocumentNameText, NameCellContainer } from './styles';

const documentColumn = {
  field: 'documentName',
  headerName: 'Document',
  flex: 2,
  nativeFilter: true,
  renderCell: ({ row }: { row: MyAcknowledgementRow }) => (
    <NameCellContainer>
      <DocumentNameText>{row.document.name}</DocumentNameText>
    </NameCellContainer>
  ),
};

const statusColumn = {
  field: 'state',
  headerName: 'Status',
  flex: 1,
  nativeFilter: true,
  sortable: false,
  renderCell: ({ row }: { row: MyAcknowledgementRow }) => <AcknowledgementStateChip state={row.state} />,
};

const dueDateColumn = {
  field: 'dueDate',
  headerName: 'Due date',
  flex: 1,
  nativeFilter: true,
  // An acknowledged row is never "overdue", so it renders muted with no red; a pending row shows the
  // standard overdue-aware due date.
  renderCell: ({ row }: { row: MyAcknowledgementRow }) =>
    row.state === AcknowledgementState.Acknowledged ? (
      <Value $color={colors.text.secondary}>{formatDateOmitCurrentYear(row.request.dueDate)}</Value>
    ) : (
      <StyledTaskDueDate date={row.request.dueDate} />
    ),
};

export const acknowledgementColumns = [documentColumn, statusColumn, dueDateColumn] as unknown as ColumnDefinition[];
